import React, { FC, useMemo } from 'react'
import LaneArrowIcon from 'transfix-icons/build/LaneArrowIcon'
import { Box, Typography } from 'transfix-ui/core'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'
import { fmtLocationStr } from 'apps/fleet-planner/utils/bookableShipmentSavedSearch'

interface BookableShipmentSavedSearchAlertLocationsProps {
  savedSearch: BookableShipmentSavedSearch
}
export const fmtRadiusStr = (radius?: number | null | string) => (radius ? `+${radius}` : '')

export const BookableShipmentSavedSearchAlertLocations: FC<BookableShipmentSavedSearchAlertLocationsProps> = ({
  savedSearch,
}) => {
  const pickupLocationStr = useMemo(
    () => fmtLocationStr({ city: savedSearch.pickupCity, stateCode: savedSearch.pickupStateCode }),
    [savedSearch.pickupCity, savedSearch.pickupStateCode]
  )
  const pickupRadiusStr = useMemo(() => fmtRadiusStr(savedSearch.pickupMiles), [
    savedSearch.pickupMiles,
  ])

  const deliveryLocationStr = useMemo(
    () =>
      fmtLocationStr({ city: savedSearch.deliveryCity, stateCode: savedSearch.deliveryStateCode }),
    [savedSearch.deliveryCity, savedSearch.deliveryStateCode]
  )

  const deliveryRadiusStr = useMemo(() => fmtRadiusStr(savedSearch.deliveryMiles), [
    savedSearch.deliveryMiles,
  ])

  return (
    <Box display='flex' alignItems='center' flexWrap='wrap'>
      {/* Pickup Location */}
      <Box mr={0.5}>
        <Typography variant='subtitle1' noWrap>
          {pickupLocationStr}
        </Typography>
      </Box>
      {pickupRadiusStr && (
        <Box ml={1}>
          <Typography color='textSecondary' component='span'>
            {pickupRadiusStr}
          </Typography>
        </Box>
      )}
      {/* Arrow */}
      <LaneArrowIcon size='large' />
      {/* Delivery Location */}
      <Box ml={0.5}>
        <Typography variant='subtitle1' noWrap>
          {deliveryLocationStr}
        </Typography>
      </Box>
      {deliveryRadiusStr && (
        <Box ml={1}>
          <Typography color='textSecondary' component='span' variant='body2'>
            {deliveryRadiusStr}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
